import { defaultThemeDark, defaultThemeLight } from '../models/colors'
import type { RetorikThemeColors, ThemeColors } from '../models/colorTypes'

const deepMerge = (target, source): any => {
  const isObject = (obj): boolean => obj && typeof obj === 'object'

  if (!isObject(target) || !isObject(source)) {
    return source
  }

  try {
    const clonedSource = structuredClone(source)

    Object.keys(clonedSource).forEach((key) => {
      const targetValue = target[key]
      const sourceValue = clonedSource[key]

      if (targetValue || targetValue === false) {
        if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
          clonedSource[key] = [...new Set([...targetValue, ...sourceValue])]
        } else if (isObject(targetValue) && isObject(sourceValue)) {
          clonedSource[key] = deepMerge(targetValue, sourceValue)
        } else {
          clonedSource[key] = targetValue
        }
      }
    })

    return clonedSource
  } catch (e: any) {
    console.log('Retorik Framework > deep merge error : ', e.message)
    return source
  }
}

const getThemeColors = (colors?: RetorikThemeColors): ThemeColors => {
  let defaultColors: ThemeColors =
    colors?.theme === 'light' ? defaultThemeLight : defaultThemeDark
  defaultColors = deepMerge(colors, defaultColors)

  return defaultColors
}

export default getThemeColors
export { deepMerge }
